'use strict';

import FormInput from "./FormInput";

export default function FormAgreement({
    showCheckboxMedia = true,
    agreeConditionsValue = false,
    agreeMediaValue = false,
    onAgreeConditionsChange = undefined,
    onAgreeMediaChange = undefined,
    textConditions = undefined,
    textMedia = undefined,
    tag = undefined,
}) {
    
    textConditions = textConditions || __('[Agreement] Text')
    textMedia = textMedia || __('[Agreement] Agree to media')

    const conditionsLink = {
        aviola: 'terms-and-conditions',
        main: 'agreement'
    }[window.Site.brand] || ''

    const policyLink = {
        aviola: 'privacy-policy',
        main: 'personal-data-policy'
    }[window.Site.brand] || ''

    const conditionsModal = {
        aviola: 'termsAndConditionsModal',
        main: 'agreementModal'
    }[window.Site.brand] || ''

    const policyModal = {
        aviola: 'privacyPolicyModal',
        main: 'personalDataPolicyModal'
    }[window.Site.brand] || ''

    const handleConditionsClick = (value) => {
        onAgreeConditionsChange && onAgreeConditionsChange(value)
    }

    const handleMediaClick = (value) => {
        onAgreeMediaChange && onAgreeMediaChange(value)
    }

    return <React.Fragment>

        <FormInput
            type={'checkbox'}
            label={{
                tag: tag,
                text: textConditions,
                replace: [
                    {
                        text: __('[Agreement] Terms of Service'),
                        href: `${langPrefix}/` + conditionsLink,
                        target: '_blank',
                        modal: conditionsModal,
                        checkOnSuccess: true,
                    },
                    {
                        text: __('[Agreement] Privacy Policy'),
                        href: `${langPrefix}/` + policyLink,
                        target: '_blank',
                        modal: policyModal,
                        checkOnSuccess: true,
                    }
                ]
            }}
            value={agreeConditionsValue}
            onChange={value => handleConditionsClick(value)}
        />

        {showCheckboxMedia && <FormInput
            type={'checkbox'}
            label={{
                text: textMedia,
            }}
            value={agreeMediaValue}
            onChange={value => handleMediaClick(value)}
        />}

    </React.Fragment>
}
